// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tTSQy","wrapper":"styles_wrapper__iOmph","wordSlider":"styles_wordSlider__9U8Qs","word":"styles_word__97a0h"};